import { useEffect, useState } from 'react';
import { HorizontalLinearStepper } from '@wajeez-web/components/mui';
import { useQuery } from '@wajeez-web/components/helpers';
import { useParams, useNavigate } from 'react-router-dom';
import {
  ComponentTypesActions,
  useContentDispatch,
  useContentSelector,
} from '@wajeez-web/stores/content';

import { ComponentComponentTypeForm } from '../components/ComponentComponentTypeForm';
import { ComponentForm } from '../components/ComponentForm';

export const CreateComponentsComponentPage = () => {
  const navigate = useNavigate();

  const query = useQuery();

  const contentDispatch = useContentDispatch();

  const [stepperCurrentStepIndex, setStepperCurrentStepIndex] =
    useState<number>(0);
  const [typeId, setTypeId] = useState<string | undefined>(
    query.get('componentTypeId')
      ? (query.get('componentTypeId') as string)
      : undefined
  );

  const componentTypesLookups = useContentSelector(
    ({ componentTypes }) => componentTypes.componentTypesLookups
  );

  useEffect(() => {
    contentDispatch(ComponentTypesActions.getComponentTypesLookupsAsync());
  }, []);

  useEffect(() => {
    window.history.replaceState(
      null,
      '',
      `/components/new?componentTypeId=${typeId || ''}`
    );

    if (typeId) {
      setStepperCurrentStepIndex(1);
    }
  }, [typeId]);

  const renderStepperStepContent = () => {
    switch (stepperCurrentStepIndex) {
      case 0:
        return (
          <ComponentComponentTypeForm
            onSubmit={(body) => {
              setTypeId(body.typeId);
            }}
            onAddButtonClick={() => {
              navigate(`/components/new/types/new`);
            }}
            componentTypesLookups={componentTypesLookups}
          />
        );
      case 1:
        return (
          <ComponentForm
            type="Create"
            onSubmit={() => {
              navigate(`/components`);
            }}
            onItemTemplateCloneSaveAndEdit={(itemTemplateId) => {
              navigate(`/components/${itemTemplateId}/edit`);
            }}
            onItemTemplateEditButtonClick={(itemTemplateId) => {
              navigate(`/components/${itemTemplateId}/edit`);
            }}
            componentTypeId={typeId}
            onCancel={() => {
              setTypeId(undefined);

              setStepperCurrentStepIndex(
                (stepperCurrentStepIndex) => stepperCurrentStepIndex - 1
              );
            }}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="py-10 px-4">
      <div className="w-1/2 mx-auto">
        <HorizontalLinearStepper
          steps={[
            { id: '1', text: 'Choose type', isOptional: false },
            { id: '2', text: 'Create component', isOptional: false },
          ]}
          currentStepIndex={stepperCurrentStepIndex}
        />
      </div>
      <div className="mt-6">{renderStepperStepContent()}</div>
    </div>
  );
};
